import { Button, Dropdown, Menu, Select, Table, Tag } from "antd";
import PageSection from "../../../components/PageSection";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useSurvey from "../hooks/useSurvey";
import { statusColors } from "../../../utils/constants";
import { ReactComponent as StatisticIcon } from "../../../assets/icons/statistics-icon.svg";
import { ReactComponent as MoreHorizontalIcon } from "../../../assets/icons/more-horizontal-icon.svg";
import { ReactComponent as DuplicateIcon } from "../../../assets/icons/duplicate-icon.svg";
import { ReactComponent as PauseIcon } from "../../../assets/icons/pause-icon.svg";
import { ReactComponent as PlayIcon } from "../../../assets/icons/play-icon.svg";
import { ReactComponent as DeleteIcon } from "../../../assets/icons/delete-icon.svg";
import useAlert from "../../../hooks/useAlert";
import HeaderList from "../../../components/HeaderList";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { setSurveyInfo } from "../../../redux/slices/surveyInfo";

const SurveysUI = () => {
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [loadingCreateSurvey, setLoadingCreateSurvey] = useState(false);
  const [loading, setLoading] = useState(false);
  const [surveyType, setSurveyType] = useState(2);
  const { surveyList, getSurveyList, onSurveyOperation, createNewSurvey } =
    useSurvey();
  const { showAlert } = useAlert();
  const user = useSelector((state) => state.user);
  const filterData = surveyList?.data.filter(item => item.channel === surveyType)
  const dispatch = useDispatch()

  useEffect(() => {
    getSurveyListHandler();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page]);

  useEffect(() => {
    dispatch(setSurveyInfo(null))
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const getSurveyListHandler = async () => {
    setLoading(true);
    await getSurveyList({ page, datobusqueda: null });
    setLoading(false);
  };

  const columns = [
    {
      title: "Nombre de la encuesta",
      dataIndex: "survey_name",
      key: "survey_name",
    },
    {
      title: "Fecha de creación",
      dataIndex: "creation_date",
      key: "creation_date",
      render: (date) => moment(date).format("DD/MM/YYYY"),
    },
    {
      title: "Número de preguntas",
      dataIndex: "items",
      key: "items",
    },
    {
      title: "Estado",
      dataIndex: "state_name",
      key: "state_name",
      render: (status, record) => (
        <Tag
          style={{
            color: "#000000",
            fontSize: 16,
            padding: "8px 16px",
            borderRadius: 50,
          }}
          color={statusColors[record.state]}
        >
          {status}
        </Tag>
      ),
    },
    {
      title: "Acción",
      key: "actions",
      render: (_, record) => (
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <Button
            style={{ width: 100, fontWeight: 700 }}
            type="default"
            onClick={() => {
              navigate(`/ajustes/encuestas/${record.id}/inicio`);
            }}
            shape="round"
          >
            Ver
          </Button>
          <Button
            title={
              record.items === 0
                ? "La encuesta no tiene datos de estadísticas"
                : ""
            }
            disabled={record.items === 0}
            onClick={() => {
              navigate(`/ajustes/encuestas/estadisticas/${record.id}`);
            }}
            style={{
              width: 40,
              height: 40,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              padding: 0,
            }}
            icon={<StatisticIcon />}
            type="default"
            shape="round"
          ></Button>
        </div>
      ),
    },
    {
      title: "Operaciones",
      key: "operations",
      render: (_, record) => (
        <Dropdown
          overlay={
            <Menu>
              <Menu.Item
                key="0"
                icon={<DuplicateIcon />}
                onClick={async () => {
                  setLoading(true);
                  const res = await onSurveyOperation({
                    operation: "duplicate",
                    id_survey: record.id,
                  });
                  if (res) {
                    return getSurveyListHandler();
                  }
                  setLoading(false);
                }}
              >
                Duplicar
              </Menu.Item>

              <Menu.Item
                key="1"
                icon={record.state !== 3 ? <PauseIcon /> : <PlayIcon />}
                onClick={() => {
                  showAlert({
                    title:
                      record.state !== 3
                        ? "¿Pausar encuesta?"
                        : "¿Reanudar encuesta?",
                    content:
                      record.state !== 3
                        ? "Mientras la encuesta esté pausada, los usuarios no podrán responderla. Podrás reanudarla en cualquier momento."
                        : "La encuesta estará activa nuevamente y los usuarios podrán responderla.",
                    status: "warning",
                    onOk: async () => {
                      const res = await onSurveyOperation({
                        operation: record.state !== 3 ? "pause" : "resume",
                        id_survey: record.id,
                      });
                      if (res) {
                        getSurveyListHandler();
                      }
                    },
                  });
                }}
              >
                {record.state !== 3 ? "Pausar" : "Reanudar"}
              </Menu.Item>

              <Menu.Item
                key="2"
                icon={<DeleteIcon />}
                danger
                onClick={() => {
                  showAlert({
                    title: "¿Eliminar encuesta?",
                    content:
                      "Esta acción no se puede deshacer. La encuesta y todos sus datos asociados serán eliminados permanentemente.",
                    onOk: async () => {
                      const res = await onSurveyOperation({
                        operation: "delete",
                        id_survey: record.id,
                      });
                      if (res) {
                        getSurveyListHandler();
                      }
                    },
                  });
                }}
              >
                Eliminar
              </Menu.Item>
            </Menu>
          }
        >
          <Button
            style={{ width: 40, border: "none" }}
            icon={<MoreHorizontalIcon />}
            type="text"
          />
        </Dropdown>
      ),
      align: "center",
    },
  ];

  return (
    <>
      <HeaderList title={"Encuestas"} back={"/ajustes"} />
      <PageSection
        title="Encuestas"
        actions={
          <div>
            <Select
              value={surveyType}
              onChange={(value) => setSurveyType(value)}
              style={{ width: 256, marginRight: 16 }}
              placeholder="Seleccionar"
              options={[
                {
                  label: "Delivery",
                  value: 2,
                },
                {
                  label: "Takeout",
                  value: 1,
                },
              ]}
            />
            <Button
              onClick={async () => {
                setLoadingCreateSurvey(true);
                const res = await createNewSurvey(user.info.email, surveyType);
                setLoadingCreateSurvey(false);

                if (res) {
                  navigate(`/ajustes/encuestas/${res.id}/inicio`);
                }
              }}
              style={{ width: 158 }}
              loading={loadingCreateSurvey}
              type="primary"
              //   shape="round"
            >
              Crear encuesta
            </Button>
          </div>
        }
      >
        <Table
          loading={loading}
          columns={columns}
          dataSource={filterData}
          rowKey={(record) => record.id}
          pagination={{
            pageSize: surveyList?.registros_por_pagina,
            total: surveyList?.total_registros,
            current: page,
            onChange: (page) => {
              setPage(page);
            },
            // showTotal: (total) => `Total registros: ${total}`,
          }}
        />
      </PageSection>
    </>
  );
};

export default SurveysUI;
